<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Ryan’s legacy comes from generations of plumbers and mechanical tradesmen. Growing up in a small business, and surrounded by colorful people has shaped Ryan into the person he is today. Discovering his love of writing while in college, Ryan used any and all spare time to develop his creative works, which would one day become more than just a dream.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4856b9be